// extracted by mini-css-extract-plugin
export default {"group":"ElevationChart--group--2hZ1E","infoBox":"ElevationChart--infoBox--KH9Rj","value":"ElevationChart--value--ixEI2"};